class AppConfig {
    
    encryptionKey = "";
    datadogClientToken = "";

    setEncryptionKey(key) {
        this.encryptionKey = key;
    }

    getEncryptionKey() {
        return this.encryptionKey;
    }

    setDatadogClientToken(token) {
        this.datadogClientToken = token;
    }

    getDatadogClientToken() {
        return this.datadogClientToken;
    }

}

export const appConfig = new AppConfig();